import React from "react";
import "./Stat.css";

function Stat({ label, value, unit, tone = "default", size = "md", hint }) {
    return (
        <div className={`stat stat--${tone} stat--${size}`}>
            <div className="stat__label uppercase-label">{label}</div>
            <div className="stat__value mono-num">
                <span className="stat__num">{value}</span>
                {unit && <span className="stat__unit">{unit}</span>}
            </div>
            {hint && <div className="stat__hint">{hint}</div>}
        </div>
    );
}

export default Stat;
